import './client-app.css';

/**
 * hub.360face.pt/privacy — privacy policy of the 360°FACE client app (App Store requirement,
 * owner 22.10.2026). Plain description of what the app and Hub actually process; to be reviewed by
 * the company's lawyer before the App Store submission.
 */
export const PRIVACY_UPDATED = '22 October 2026';

export function Privacy() {
  return (
    <main className="ca-page ca-legal">
      <a className="ca-link" href="/app">
        ← 360°FACE
      </a>
      <h1 className="ca-h1">
        Privacy policy <small>Política de privacidade</small>
      </h1>
      <p className="ca-muted">Last updated: {PRIVACY_UPDATED}</p>

      <section className="ca-card">
        <h2>Who we are</h2>
        <p>
          SENTIDINVULGAR, UNIPESSOAL, LDA (NIPC 518136574), Rua Gago Coutinho 82, 2785-154 São Domingos de Rana,
          Portugal — operator of the 360°FACE studios in Parede and Lisboa. Contact:{' '}
          <a href="mailto:info@360face.pt">info@360face.pt</a>.
        </p>
        <h2>What we process and why</h2>
        <ul>
          <li>
            <b>Booking</b>: name, phone, e-mail, chosen treatment, therapist and time — to make and manage your booking.
            Stored in our booking system (Altegio).
          </li>
          <li>
            <b>My bookings</b>: your e-mail and a one-time code (valid 10 minutes) to show your upcoming bookings. The
            app keeps a sign-in key on your phone for 30 days; «Sign out» deletes it.
          </li>
          <li>
            <b>Pre-visit questionnaire</b> (if you fill it in): kept encrypted and the details are deleted on the day of
            your visit; the therapist sees only what is needed for a safe treatment.
          </li>
          <li>
            <b>E-mails</b>: booking confirmations, a confirmation request and, after the visit, your therapist's care
            advice. The advice text may be translated automatically by DeepL (EU).
          </li>
        </ul>
        <p>
          Legal bases: performance of the service you book (GDPR art. 6(1)(b)), legal obligations (invoicing), and your
          consent for the questionnaire (art. 9(2)(a)).
        </p>
        <h2>What we do not do</h2>
        <p>
          No advertising, no tracking across apps or websites, no analytics cookies, no sale of data. Payments are not
          made in the app.
        </p>
        <h2>Where data is kept</h2>
        <p>
          On our server in the European Union and in our booking system. Service providers process data only on our
          instructions.
        </p>
        <h2>How long</h2>
        <p>
          Booking records as long as needed for the service and as required by Portuguese law (e.g. invoicing). Sign-in
          codes: 10 minutes. Questionnaire details: until the end of the visit day.
        </p>
        <h2>Your rights</h2>
        <p>
          Access, correction, deletion, restriction, portability and objection — write to{' '}
          <a href="mailto:info@360face.pt">info@360face.pt</a>. You may also complain to the Portuguese data protection
          authority, CNPD (<a href="https://www.cnpd.pt">www.cnpd.pt</a>).
        </p>
      </section>

      <section className="ca-card" lang="pt">
        <h2>Resumo em português</h2>
        <p>
          Responsável: SENTIDINVULGAR, UNIPESSOAL, LDA (NIPC 518136574), Rua Gago Coutinho 82, 2785-154 São Domingos de
          Rana. Tratamos nome, telefone, e-mail e dados da marcação para gerir as suas marcações (sistema Altegio); o
          e-mail e um código único (10 minutos) para «As minhas marcações»; o questionário de saúde, se o preencher, é
          cifrado e os detalhes são apagados no dia da visita. Sem publicidade, sem rastreamento, sem venda de dados,
          sem pagamentos na aplicação. Dados num servidor na União Europeia. Pode exercer os seus direitos (acesso,
          retificação, apagamento, oposição, portabilidade) através de{' '}
          <a href="mailto:info@360face.pt">info@360face.pt</a> e apresentar reclamação à CNPD.
        </p>
      </section>
    </main>
  );
}
